import { RolesContext } from "@/context/RolesContext";
import { useContext } from "react";

export const useRoles = () => {
  const context = useContext(RolesContext);
  if (!context)
    throw new Error("useRoles debe ser usado dentro de RolesProvider");

  return context;
};
